// extracted by mini-css-extract-plugin
module.exports = {"title":"no-results_title__Wy9FK","content":"no-results_content__iUn8n"};